import { PromoComponentImportPage } from "@/features/promo/pages/PromoComponentImportPage";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/admin/promo/$id/import")({
	validateSearch: z.object({
		promoTypeID: z.string().uuid(),
	}),
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["promo.edit"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: RouteComponent,
});

function RouteComponent() {
	const { id } = Route.useParams();
	const { promoTypeID } = Route.useSearch();
	return <PromoComponentImportPage promoID={id} promoTypeID={promoTypeID} />;
}
